import { capitalizeWords } from "@/functions/capitalizeFirstLetters";
import { MetaRatingIcon } from "@/icons";

import { Tier as TierType } from "../../../../redux/players/playersSlice";
import { Tier } from "../../../atoms/Tier/Tier";

type Props = {
  rewardType: "pack" | "item" | "playerpick" | "player" | "cosmetic-evo";
  description: string;
  playerRole?: string;
  rewardName?: string;
  rewardMetaRating?: number;
  untradeable?: boolean;
  tier?: TierType;
};

export const SBCRewardDescription = ({
  rewardType,
  description,
  playerRole,
  rewardName,
  rewardMetaRating,
  untradeable,
  tier,
}: Props) => {
  return rewardType === "player" ? (
    <div className="flex flex-col text-left gap-y-1">
      <span className="text-sm desktop:text-base text-dark-secondary">
        {playerRole}
      </span>
      <div className="flex flex-row items-center gap-x-1">
        <div className="text-dark-tertiary">
          <MetaRatingIcon width="20" height="20" />
        </div>
        <span className="text-sm font-medium desktop:text-base text-dark-secondary">
          {rewardMetaRating?.toFixed(1)}
        </span>
        {tier && (
          <div className="font-semibold ml-2">
            <Tier tier={tier} small />
          </div>
        )}
      </div>
      <span className="mt-2 text-xs text-dark-tertiary">{description}</span>
    </div>
  ) : (
    <div className="flex flex-col h-full ml-1 text-left desktop:ml-0">
      <p className="text-dark-secondary text-sm desktop:-mt-[6px] desktop:text-base">
        {capitalizeWords(rewardName)}
      </p>
      <span className="text-xs text-dark-tertiary">
        {rewardType === "cosmetic-evo"
          ? ""
          : untradeable
            ? "[UNTRADEABLE]"
            : "[TRADEABLE]"}
      </span>
      <span className="mt-2 text-xs text-dark-tertiary">{description}</span>
    </div>
  );
};
